module.exports = __webpack_public_path__ + "static/media/quota-panel.5a7ca3f8.png";